const options = {
  5: "bg-slate-400/5",
  10: "bg-slate-400/10",
  25: "bg-slate-400/25",
  50: "bg-slate-400/50",
  75: "bg-slate-400/75",
  90: "bg-slate-400/90",
  100: "bg-slate-400",
};

const from = {
  5: "from-slate-400/5",
  10: "from-slate-400/10",
  25: "from-slate-400/25",
  50: "from-slate-400/50",
  75: "from-slate-400/75",
  90: "from-slate-400/90",
  100: "from-slate-400",
};

export default function getBackgroundSlate400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
